<template>
    <v-card outlined>
        <v-card-title
            ><span class="mx-auto"
                >{{ administrator.name }}
                <v-icon v-if="included" class="ml-2" color="primary"
                    >mdi-check-circle</v-icon
                ></span
            >
        </v-card-title>
        <v-card-text class="d-flex align-center">
            <v-avatar size="120">
                <v-img :src="administrator.medium_profile_photo_url"></v-img>
            </v-avatar>
            <div class="ml-6">
                <h3 class="font-weight-regular mb-1">
                    <v-icon class="mr-3">{{ $config("icons.email") }}</v-icon
                    >{{ administrator.email }}
                </h3>
                <h3 class="font-weight-regular mb-1">
                    <v-icon class="mr-3">{{ $config("icons.company") }}</v-icon
                    >{{ administrator.company.name }}
                </h3>
                <h3 class="font-weight-regular">
                    <v-icon class="mr-3">{{ $config("icons.role") }}</v-icon
                    >{{ administrator.role_name }}
                </h3>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "program-admin",
    props: {
        administrator: {
            type: Object,
            required: true,
        },
        included: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            switch1: false,
        };
    },
    computed: {},
};
</script>

<style lang="scss" scoped>
</style>